import { SizeBubble } from "./bubbles/SizeBubble";
import { Header } from "./Header";
import { ExpandingTooltipReturn } from "./hooks/useAdvancedTooltip";
import "../styles/sizeHeader.css";

export { SizeHeader };

type Props = {
  array: Array<any> | number;
  children: string;
  className?: string;
  tProps?: ExpandingTooltipReturn["triggerProps"];
};

const SizeHeader = (props: Props) => {
  return (
    <div className={"sizeHeader " + (props.className ?? "")}>
      <Header {...props.tProps}>{props.children}</Header>
      <SizeBubble
        length={Array.isArray(props.array) ? props.array.length : props.array}
      />
    </div>
  );
};
